/*
  Tokyo Romance Club — PDP only (no-ops everywhere else): keeps the fixed
  Back to Top button clear of the Mobile Sticky Add to Cart bar.

  Does not modify the Sticky Add to Cart bar (assets/sticky-add-to-cart.js /
  sections/product-information.liquid) or Back to Top's own markup/behavior
  (assets/trc-back-to-top.js) — it only observes the bar's native
  `data-stuck` attribute and real measured height, then toggles a class +
  CSS custom property that trc-pdp-sticky-offset.css uses to reposition
  Back to Top. Never runs inside the theme editor (the button itself isn't
  even rendered there — see snippets/trc-back-to-top.liquid).
*/
(function () {
  if (window.__trcPdpStickyOffsetInit) return;
  window.__trcPdpStickyOffsetInit = true;

  if (document.documentElement.classList.contains('shopify-design-mode')) return;

  var ACTIVE_CLASS = 'trc-sticky-cart-active';
  var HEIGHT_VAR = '--trc-sticky-cart-height';

  function init() {
    var bar = document.querySelector('.sticky-add-to-cart__bar');
    if (!bar) return;

    var mql = window.matchMedia('(max-width: 749px)');

    function updateHeight() {
      document.documentElement.style.setProperty(HEIGHT_VAR, bar.getBoundingClientRect().height + 'px');
    }

    function sync() {
      var isStuck = bar.getAttribute('data-stuck') === 'true';
      if (isStuck && mql.matches) {
        updateHeight();
        document.documentElement.classList.add(ACTIVE_CLASS);
      } else {
        document.documentElement.classList.remove(ACTIVE_CLASS);
      }
    }

    new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['data-stuck'] });

    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        if (bar.getAttribute('data-stuck') === 'true') updateHeight();
      }).observe(bar);
    }

    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', sync);
    } else if (typeof mql.addListener === 'function') {
      mql.addListener(sync);
    }

    sync();
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
